import React, { useEffect, useState } from 'react';
import './Posts.css';
import publicAxios from '../../utils/axios/publicAxios';
import { Link } from 'react-router-dom';
import { Circles } from 'react-loader-spinner';
import IMAGEALT from '../../assets/images/igboezenorthlga.png';
const Posts = () => {

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);

  const stripHtmlAndTruncate = (html, maxLength = 100) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        const response = await publicAxios.get('/public/threePosts');
        setPosts(response.data.posts);
      } catch (error) {
        console.error('Error:', error)
      } finally {
        setLoading(false);
      }
    }

    fetchPosts();
  }, [])
  return (
    <section className="posts">
      {loading ? <div style={{ display: 'flex', flexDirection: 'column', columnGap: '10px', width: '100%', alignItems: 'center', justifyContent: 'center', height: '500px', color: 'gray' }}>
        <Circles height="50" width="50" color="#008751" ariaLabel="loading" /> <h2>Loading News & Events...</h2>
      </div> :
        posts.length ? <div className="posts-wrapper">
          <div className='posts-section-title-div'>
            <Link to={'/posts'} className="posts-section-title">Latest News & Events</Link>
          </div>
          <div className="posts-grid">
            {posts.map((post, index) => (
              <Link key={post._id || index} to={`/post/${post.slug}`} className='read more'>
                <div className="post-card" key={post._id || index}>
                  <div className="post-image">
                    {post.imageUrl ?
                      <img src={post.imageUrl} alt={post.title} loading='lazy' /> :
                      <div>
                        <img src={IMAGEALT} alt={post.title} loading='lazy' className='imagealt' />
                      </div>}
                  </div>
                  <div className="post-details">
                    <h3>{stripHtmlAndTruncate(post.title, 90)}</h3>
                    {/* <p>{stripHtmlAndTruncate(event.content, 150)}</p>
                    <div className='posts-read-more-div'>
                      Read more...</Link>
                    </div> */}
                  </div>

                </div>
              </Link>
            ))}
          </div>
        </div> :
          // <div>No News & Events found.</div>
          null
      }
    </section>
  );
};

export default Posts;